import { QueryResult, useQuery } from 'react-query';

export enum Controller {
    authenticate = 'authenticate',
    kunde = 'kunde',
    termin = 'termin',
    wiedervorlage = 'wiedervorlage',
    ansprechpartner = 'ansprechpartner',
    zusatzadresse = 'zusatzadresse',
    maschinenkunde = 'maschinenkunde',
    angebot = 'angebot',
    angebotPosition = 'angebotposition',
    auftrag = 'auftrag',
    auftragPosition = 'auftragposition',
    lieferung = 'lieferung',
    lieferungPosition = 'lieferungposition',
    rechnung = 'rechnung',
    rechnungPosition = 'rechnungposition',
    bestellung = 'bestellung',
    bestellungPosition = 'bestellungposition',
    service = 'service',
    servicePosition = 'servicePosition',
    lieferantenrechnung = 'lieferantenrechnung',
    lieferantenrechnungPosition = 'lieferantenrechnungposition',
    lieferantenrechnungAraPosition = 'lieferantenrechnungaraposition',
    lookup = 'lookup',
    artikel = 'artikel',
    artikelDetail = 'artikeldetail',
    artikelDetailLieferant = 'artikeldetaillieferant',
    artikelMaschinentype = 'artikelmaschinentype',
    artikelDetailKalkulation = 'artikeldetailkalkulation',
    artikelEigenschaft = 'artikeleigenschaft',
    artikelEigenschaftLink = 'artikeleigenschaftlink',
    attachment = 'attachment',
    artikelAttachment = 'artikelAttachment',
    terminAttachment = 'terminAttachment',
    bmd = 'bmd',
    betreuer = 'betreuer',
    betreuerWorkMonth = 'betreuerworkmonth',
    betreuerWorkDay = 'betreuerworkday',
    textbaustein = 'textbaustein',
    skontodefinition = 'skontodefinition',
    kontodefinition = 'kontodefinition',
    produzent = 'produzent',
    branche = 'branche',
    interesseFuerProdukte = 'interessefuerprodukte',
    erweiterteSuche = 'erweitertesuche',
    araRegelung = 'araregelung',
    produktgruppe = 'produktgruppe',
    maschinentype = 'maschinentype',
}

export function getApiUrl(controller: string): string {
    if (
        window.location.host === 'localhost:3000' ||
        window.location.host === '10.221.0.52:3000' ||
        window.location.host === 'salesmaster-dev.bdspack.at'
    ) {
        // return 'https://salesmaster.bdspack.at/api/' + controller;
        return 'https://salesmaster-dev.bdspack.at:8443/api/' + controller;
    }

    return '/api/' + controller;
}

export async function callApi<TResult>(controller: string, body: unknown): Promise<TResult> {
    const request: RequestInit = {
        method: 'post',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };

    const responseRaw = await fetch(getApiUrl(controller), request);

    if (responseRaw.status === 200) {
        return (await responseRaw.json()) as Promise<TResult>;
    }

    throw new Error(await responseRaw.text());
}

export interface UseApiOptions<TResult> {
    enabled?: boolean;
    allowCaching?: boolean;
    staleTime?: number;
    onSuccess?: (data: TResult) => void;
}

export function useApi<TResult>(
    controller: string,
    body: unknown,
    options?: UseApiOptions<TResult>,
): QueryResult<TResult> {
    const bodyJSON = JSON.stringify(body);

    return useQuery<TResult>(
        controller + ':' + bodyJSON,
        async () => {
            return callApi<TResult>(controller, body);
        },
        {
            enabled: options?.enabled === undefined ? true : options?.enabled,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            retry: false,
            cacheTime: options?.allowCaching === true ? 60000 : 0,
            staleTime: options?.staleTime === undefined ? 60000 : options?.staleTime,
            onSuccess: options?.onSuccess,
        },
    );
}
